module.exports = __webpack_public_path__ + "img/down.d5698ed4.svg";